import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const OpenBlueWaterPage = () => {
  const data = getCharterBySlug('open-blue-water');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default OpenBlueWaterPage;
